export { GameListComponent } from './game-list/game-list.component';
export { GameWinLosePageComponent } from './game-win-lose-page/game-win-lose-page.component';